import { DEFAULT_ENCODER_CONFIG } from '@gem/call/constants';
import { platformInfo } from '@gem/utils';

async function getPermission({
  hasAudio,
  hasVideo,
}: {
  hasAudio?: boolean;
  hasVideo?: boolean | { deviceId: string };
}): Promise<boolean> {
  let stream;

  let hasVideoConstraints: boolean | object = false;

  if (hasVideo) {
    hasVideoConstraints =
      typeof hasVideo === 'boolean'
        ? DEFAULT_ENCODER_CONFIG
        : { ...hasVideo, ...DEFAULT_ENCODER_CONFIG };
  }
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: hasAudio,
      video: hasVideoConstraints,
    });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  } finally {
    if (stream) {
      stream.getTracks().forEach((t) => {
        t.stop();
      });
    }
  }
}

export async function getAudioPermission(): Promise<boolean> {
  if (platformInfo.isElectron) {
    return await window.electronAPI.getMediaPermission({
      hasAudio: true,
      hasVideo: false,
    });
  }

  return await getPermission({
    hasAudio: true,
    hasVideo: false,
  });
}

export async function getVideoPermission(deviceId?: string): Promise<boolean> {
  if (platformInfo.isElectron) {
    return await window.electronAPI.getMediaPermission({
      hasAudio: false,
      hasVideo: true,
    });
  }

  return await getPermission({
    hasAudio: false,
    hasVideo: deviceId ? { deviceId } : true,
  });
}

export async function getMediaPermission(): Promise<boolean> {
  if (platformInfo.isElectron) {
    return await window.electronAPI.getMediaPermission({
      hasAudio: true,
      hasVideo: true,
    });
  }

  return await getPermission({
    hasAudio: true,
    hasVideo: true,
  });
}
